
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M66.004 0h-59A7.025 7.025 0 002.05 2.04 6.942 6.942 0 000 6.962V37h66.004a7.033 7.033 0 004.95-2.041 6.95 6.95 0 002.053-4.922V6.963a6.927 6.927 0 00-2.051-4.924A7.04 7.04 0 0066.003 0z","fill":"#009CB4"}}),_c('path',{attrs:{"d":"M16.94 26.504c-4.443 0-7.693-3.525-7.693-8.17 0-4.644 3.258-7.846 7.692-7.846h8.574v2.142h-8.574c-3.19 0-5.537 2.377-5.537 5.815 0 3.437 2.324 5.888 5.537 5.888h8.574v2.134l-8.574.037zM28.016 26.504V24.37h11.986c1.8 0 2.747-1.038 2.747-2.532 0-1.656-.97-2.495-2.747-2.495h-7.53c-2.901 0-4.7-1.914-4.7-4.468 0-2.554 1.665-4.416 4.745-4.416h11.498v2.142H32.517a2.396 2.396 0 00-1.77.644A2.37 2.37 0 0030 14.967a2.358 2.358 0 00.746 1.722 2.387 2.387 0 001.771.645h7.508c3.124 0 4.79 1.545 4.79 4.563 0 2.62-1.577 4.578-4.79 4.578l-12.01.03zM49.42 13.704v12.8H47.36V11.605c0-.817.445-1.325 1.126-1.325a1.488 1.488 0 011.021.508L61.71 23.2v-12.8h2.058v15.008c0 .81-.46 1.295-1.081 1.295a1.628 1.628 0 01-1.11-.552L49.42 13.704z","fill":"#fff"}})])
          )
        }
      }
    